import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddIdentityDocumentTypes, IdentityDocumentTypes } from '../models/identitydocumenttypes/identitydocumenttypes';


@Injectable({
  providedIn: 'root'
})
export class IdentityDocumentTypesService {

  constructor(
    private _http: HttpClient
  ) { }

    public getIdentityDocumentTypes(IdentityDocumentTypesId?: number): Observable<IdentityDocumentTypes[]>{
        return this._http.get<IdentityDocumentTypes[]>(`${environment.api.url}/IdentityDocumentTypes?IdentityDocumentTypesId=${IdentityDocumentTypesId??''}`);
    }
  
    public deleteIdentityDocumentTypes(IdentityDocumentTypesId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/IdentityDocumentTypes/${IdentityDocumentTypesId}`);
    }
  
    public addIdentityDocumentTypes(model: AddIdentityDocumentTypes): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/IdentityDocumentTypes`, model);
    }
}
